import styled from 'styled-components';
import { getTextColor } from '@magalu/stereo-ui-styles';
import Box from '../../../atoms/Box';
export const Content = Box;
export const LuDetailContent = styled(Box)`
  padding: 0 14px 14px 14px;
  img {
    width: 100% !important;
    height: auto !important;
  }
  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
    line-height: 20px;
  }
  a {
    color: ${props => getTextColor('primary')(props)};
    text-decoration: none;
  }
`;